import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { BankRule, BankRuleRequest, RuleKindInfo } from '../interfaces/bank/bankRule.interface';
import { CashSide, CategorySuggestRequest, CategorySuggestion } from '../interfaces/cashbook/cashbook.interface';

/** F11 (11c): transaction mapping rules (rule kind TXN_MAPPING, one list per side) and the cash form's "Auto" preview. */
export type TxnMappingRuleRequest = BankRuleRequest & { subjectType: CashSide };

export const TxnMappingRuleService = {
  fields: async (subjectType: CashSide): Promise<RuleKindInfo> =>
    (await axios.get(ENDPOINTS.TXN_MAPPING_RULES.FIELDS, { params: { subjectType } })).data,
  list: async (institutionId: string, subjectType: CashSide, params?: { active?: boolean; search?: string }): Promise<BankRule[]> =>
    (await axios.get(ENDPOINTS.TXN_MAPPING_RULES.LIST(institutionId), { params: { subjectType, ...params } })).data,
  create: async (institutionId: string, dto: TxnMappingRuleRequest): Promise<BankRule> =>
    (await axios.post(ENDPOINTS.TXN_MAPPING_RULES.LIST(institutionId), dto)).data,
  update: async (institutionId: string, ruleId: string, dto: TxnMappingRuleRequest): Promise<BankRule> =>
    (await axios.put(ENDPOINTS.TXN_MAPPING_RULES.ONE(institutionId, ruleId), dto)).data,
  setActive: async (institutionId: string, ruleId: string, active: boolean): Promise<BankRule> =>
    (await axios.post(active ? ENDPOINTS.TXN_MAPPING_RULES.ACTIVATE(institutionId, ruleId)
      : ENDPOINTS.TXN_MAPPING_RULES.DEACTIVATE(institutionId, ruleId))).data,
  reorder: async (institutionId: string, subjectType: CashSide, ruleIds: string[]): Promise<BankRule[]> =>
    (await axios.put(ENDPOINTS.TXN_MAPPING_RULES.ORDER(institutionId), { subjectType, ruleIds })).data,
  remove: async (institutionId: string, ruleId: string): Promise<void> => {
    await axios.delete(ENDPOINTS.TXN_MAPPING_RULES.ONE(institutionId, ruleId));
  },
  suggest: async (institutionId: string, req: CategorySuggestRequest): Promise<CategorySuggestion> =>
    (await axios.post(ENDPOINTS.TRANSACTION.SUGGEST_CATEGORY(institutionId), req)).data,
};
